import React, { FunctionComponent, HTMLAttributes } from 'react';

import { Empty } from '@yandex-360/orb-components/dist/components/Empty';
import cn from 'classnames';

import { Link } from '../../../../../components';
import I18N from '../../../../../components/i18n';
import { Island } from '../island';
import css from './styles.css';

export interface UnsupportedBrowserStubProps extends Pick<HTMLAttributes<HTMLDivElement>, 'className'> {
    title: string;
}

export const UnsupportedBrowserStub: FunctionComponent<UnsupportedBrowserStubProps> = ({ className, title }) => {
    const stubClasses = cn(css.stubWrapper, className);

    return (
        <Island className={stubClasses}>
            <Empty
                title={title}
                description={
                    <I18N keyset="settings-v2" loc="video-change-not-supported-description">
                        <Link data-ref="link-telemost" className={css.link} href="/download-desktop" target="_blank" />
                        <Link
                            data-ref="link-yabro"
                            className={css.link}
                            href="https://browser.yandex.ru"
                            target="_blank"
                        />
                    </I18N>
                }
            />
        </Island>
    );
};
